var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("global.reports")))]),
      _c("booking-menu"),
      _vm.extendedFilters
        ? _c("booking-report-extended-filters", {
            attrs: {
              "selected-columns": _vm.selectedColumns,
              "available-columns": _vm.availableColumns,
              "show-all": _vm.showAll,
              filters: _vm.filtersObject,
              downloadable: ""
            },
            on: {
              "update:selectedColumns": function($event) {
                _vm.selectedColumns = $event
              },
              "update:selected-columns": function($event) {
                _vm.selectedColumns = $event
              },
              "update:showAll": function($event) {
                _vm.showAll = $event
              },
              "update:show-all": function($event) {
                _vm.showAll = $event
              },
              "update:filters": function($event) {
                _vm.filtersObject = $event
              },
              download: _vm.download
            }
          })
        : _vm._e(),
      _vm.basicFilters
        ? _c("booking-report-base-filters", {
            attrs: {
              "selected-columns": _vm.selectedColumns,
              "available-columns": _vm.availableColumns,
              "from-date": _vm.filtersObject.fromDate,
              "to-date": _vm.filtersObject.toDate,
              "selected-types": _vm.filtersObject.selectedTypes,
              "show-all": _vm.showAll,
              downloadable: ""
            },
            on: {
              "update:selectedColumns": function($event) {
                _vm.selectedColumns = $event
              },
              "update:selected-columns": function($event) {
                _vm.selectedColumns = $event
              },
              "update:fromDate": function($event) {
                return _vm.$set(_vm.filtersObject, "fromDate", $event)
              },
              "update:from-date": function($event) {
                return _vm.$set(_vm.filtersObject, "fromDate", $event)
              },
              "update:toDate": function($event) {
                return _vm.$set(_vm.filtersObject, "toDate", $event)
              },
              "update:to-date": function($event) {
                return _vm.$set(_vm.filtersObject, "toDate", $event)
              },
              "update:selectedTypes": function($event) {
                return _vm.$set(_vm.filtersObject, "selectedTypes", $event)
              },
              "update:selected-types": function($event) {
                return _vm.$set(_vm.filtersObject, "selectedTypes", $event)
              },
              "update:showAll": function($event) {
                _vm.showAll = $event
              },
              "update:show-all": function($event) {
                _vm.showAll = $event
              },
              download: _vm.download
            }
          })
        : _vm._e(),
      _c("booking-report-download-component", {
        attrs: {
          options: _vm.pagination,
          dialog: _vm.downloadDialog,
          type: _vm.type,
          columns: _vm.selectedColumns,
          filters: _vm.filtersObject
        },
        on: {
          "update:dialog": function($event) {
            _vm.downloadDialog = $event
          }
        }
      }),
      _c("v-data-table", {
        attrs: {
          items: _vm.resp,
          headers: _vm.headers,
          options: _vm.pagination,
          loading: _vm.$store.getters["Ajax/loading"],
          "must-sort": ""
        },
        on: {
          "update:options": function($event) {
            _vm.pagination = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c(
                  "tr",
                  [
                    _vm._l(_vm.selectedColumns, function(column) {
                      return _c(
                        "td",
                        { key: column },
                        [
                          column === "name"
                            ? [
                                _c("h3", [
                                  _vm._v(" " + _vm._s(props.item.name) + " "),
                                  props.item.currency === ""
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("global.noInvoiceYet"))
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              ]
                            : _vm._e(),
                          _c(
                            "booking-report-standard-header-column-component",
                            {
                              attrs: {
                                column: column,
                                "currency-content": props.item
                              }
                            }
                          )
                        ],
                        2
                      )
                    }),
                    _c(
                      "td",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function($event) {
                                return _vm.showItem(props.item.name)
                              }
                            }
                          },
                          [
                            !_vm.showItems.includes(props.item.name)
                              ? _c("v-icon", [_vm._v("keyboard_arrow_down")])
                              : _c("v-icon", [_vm._v("keyboard_arrow_up")])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  2
                ),
                _vm._l(props.item.items, function(bookingItem) {
                  return _vm.showItems.includes(props.item.name)
                    ? _c(
                        "tr",
                        { key: bookingItem.id },
                        [
                          _vm._l(_vm.selectedColumns, function(column) {
                            return _c(
                              "td",
                              { key: column },
                              [
                                _c("booking-report-currency-item-component", {
                                  attrs: {
                                    "booking-item": bookingItem,
                                    column: column,
                                    currency: props.item.currency,
                                    "selected-columns": _vm.selectedColumns
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          _c("td")
                        ],
                        2
                      )
                    : _vm._e()
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }